module.exports = __webpack_public_path__ + "static/globalMenu_ssd-2844180d38fbd6e382742607bf7a4003.png";